import ApiInterface from "@/commons/api/ApiInterface";

export const loadFileInfos = (fileUUID, prevFileSetter, nextFileSetter, fileNameSetter, alternativeFileSetter, fromPath, toPath) => {
    prevFileSetter(null);
    nextFileSetter(null);
    alternativeFileSetter(null);
    fileNameSetter("");
    ApiInterface.getFileInfo(fileUUID).then(async info => {
        let {fileName, filePath} = info;
        let rotatedName = fileName.split(".txt")[0];
        let finalName = rotatedName.split("-")[2] + "." +  rotatedName.split("-")[1] + "." + rotatedName.split("-")[0];
        fileNameSetter(finalName);

        getFileFromPath(filePath.replace(fromPath, toPath)).then((alternativeFile) => {
            if(alternativeFile)
                alternativeFileSetter(alternativeFile);
        });

        getDayFile(filePath, -1).then((prevDayFile) => {
            if(prevDayFile)
                prevFileSetter(prevDayFile);
        });
        getDayFile(filePath, 1).then((nextDayFile) => {
            if(nextDayFile)
                nextFileSetter(nextDayFile);
        });
    });
}
async function getDayFile(filePath, days) {
    // Estrai la data dal path (YYYY-MM-DD)
    const match = filePath.match(/(\d{4}-\d{2}-\d{2})\.txt$/);
    if (!match) return null;

    const dateStr = match[1];
    const date = new Date(dateStr);
    if (isNaN(date)) return null;

    // Sposta la data
    date.setDate(date.getDate() + days);

    // Riformatta la data in YYYY-MM-DD
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const newDateStr = `${yyyy}-${mm}-${dd}`;

    // Sostituisci nel path
    let newFilePath = filePath.replace(/\d{4}-\d{2}-\d{2}\.txt$/, `${newDateStr}.txt`);
    return await getFileFromPath(newFilePath);
}

let getFileFromPath = async (filePath) => {
    // Ottiene tutti gli UUID dei file
    const filesResult = await ApiInterface.getFilesUUIDS(filePath);

    if(filesResult === null) {
        return null;
    }

    if(filesResult.length === 0) return null;
    if(filesResult.length > 1) return null;
    if(filesResult.length === 1) {
        return filesResult[0];
    }
}